import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Table} from 'reactstrap';
import {toast} from 'react-toastify';

import {downloadPDF} from "../common/Constants";
import loadingGIF from "../../public/assets/images/loading.gif";
import ErrorMsg from "../common/ErrorMsg";
import AuditForm from "../staffDashboardNav/AuditForm";


const EMPTY_AUDIT = {
    id: 0,
    compensation_profile: 0,
    date_range: ''
}

export default class ArchivedAudits extends Component {
    state = {
        archivedAuditList: [],
        isLoading: false,
        openAuditForm: false,
        audit: {...EMPTY_AUDIT}
    }

    componentDidMount() {
        this.getArchivedAuditList();
    }

    getArchivedAuditList = async () => {
        this.setState({isLoading: true});
        try {
            const {user} = this.props;
            const userId = user && user.id ? user.id : 0;
            let result = await this.props.getArchivedAudits(userId);
            if (result) {
                this.setState({archivedAuditList: [...result]});
            }            
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        this.setState({isLoading: false});
    };

    onToggle = () => {
        this.setState({
            archivedAuditList: []
        });
        this.props.toggleModal();
    };

    printAuditForm = async (auditId) => {
        const {user} = this.props;
        const userId = user && user.id ? user.id : 0;
        this.setState({isLoading: true});
        let result = await this.props.printAuditResponse(userId, auditId);
        if (result) {
            let content = result.content;
            let fileName = result.file_name;
            downloadPDF(content, fileName);
        } else {
            toast.error("Audit form is not available. Please contact admin.");
        }
        this.setState({isLoading: false});
    }

    openAuditForm = (audit={...EMPTY_AUDIT}) => {
        this.setState({openAuditForm: true, audit});
    }

    toggleAuditFormModal = () => {
        this.setState({openAuditForm: false});
    };

    renderArchivedAudits = () => {
        const {archivedAuditList} = this.state;
        if (archivedAuditList.length === 0) {
            return <tr key={0}>
                <td colSpan="6" className="text-center">No saved reviews available</td>
            </tr>
        }
        return this.state.archivedAuditList.map((audit, index) =>
            <tr key={index}>
                <td className="align-middle kb-link-item text-info"
                    title="Open Audit Form and See Response"
                    onClick={() => this.openAuditForm(audit)}
                >
                    {audit.name_of_audit}
                </td>
                <td className="align-middle">{audit.date_range}</td>
                <td className="align-middle">{audit.created_at}</td>
                <td className="align-middle">{audit.updated_at}</td>
                <td className="align-middle">{audit.status_text}</td>
                <td className="align-middle cursor-pointer text-center"
                    onClick={() => this.printAuditForm(audit.id)}
                >
                    <i className="fa fa-print" title="Print Form with Response"></i>
                </td>
            </tr>
        );
    }

    render() {
        const {isLoading, audit, openAuditForm} = this.state;
        const {user} = this.props;

        return (
            <Modal isOpen={this.props.modal} size={'lg'} toggle={this.onToggle}>
                <ModalHeader toggle={this.onToggle}>
                    {`${user && user.id ? user.full_name + ' - ' : ''}`}Saved Reviews
                </ModalHeader>
                <ModalBody className="bg-white"> 
                    <Table hover striped size="sm">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Compensation Period</th>
                                <th>Created on</th>
                                <th>Last Modified on</th>
                                <th>Status</th>
                                <th className="text-center">Print</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderArchivedAudits()}
                        </tbody>
                    </Table>
                    {isLoading && 
                        <p className="loading-gif">
                            <img src={loadingGIF} alt="Loading..." width="32" height="32"/>
                        </p>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.onToggle}>Close</Button>
                </ModalFooter>
                {openAuditForm && 
                    <AuditForm {...this.props}
                        modal={openAuditForm} 
                        toggleModal={this.toggleAuditFormModal} 
                        auditId={audit.id}
                        compensation={{
                            id: audit.compensation_profile,
                            date_range: audit.date_range
                        }}
                        isArchived={true}
                    />
                }
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/complianceAudit/ArchivedAudits.js